import React from 'react';
import { useAuth } from '../auth/useAuth';
import Dashboard from './Dashboard';
import LegacyDashboard from './LegacyDashboard';

/**
 * /dashboard. Today and Actions are still in development, so only accounts an
 * admin opts in (feature_flags.new_dashboard in User Management) see them;
 * everyone else keeps the original dashboard.
 */
const DashboardRoute: React.FC = () => {
  const { hasFeature } = useAuth();
  return hasFeature('new_dashboard') ? <Dashboard /> : <LegacyDashboard userRole="" />;
};

export default DashboardRoute;
